// main.js
import { createApp } from 'vue'
import './assets/main.css'

import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 如果要用图标（比如刷新按钮）
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)

// 全局注册 Element Plus
app.use(store).use(router).use(ElementPlus)

// // 全局注册所有图标（可选）
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//     app.component(key, component)
// }

app.mount('#app')
